import { ArrayResolution, type Filter } from '@fabric-ui/components';
import { mapFilterExpressions } from './map-filter-expressions';

/**
 * Wraps every expression leaf in an array condition while preserving the filter tree structure.
 *
 * @param source - The filter tree containing scalar expression leaves.
 * @param resolution - The array resolution applied to every expression.
 * @returns A new filter tree with each expression wrapped as an array condition.
 * @throws When an expression has no field name or is already an array condition.
 *
 * @example
 * ```ts
 * wrapArrayCondition(field('tags').str.contains('finance'), ArrayResolution.ANY);
 * ```
 */
export const wrapArrayCondition = (source: Filter, resolution: ArrayResolution): Filter =>
  mapFilterExpressions(source, expression => {
    if (!expression.fieldName) throw new Error('Array condition requires a field name');
    if (expression.arrayCondition) throw new Error('Array condition cannot wrap another array condition');
    return {
      fieldName: expression.fieldName,
      arrayCondition: { underlying: expression, resolution },
    };
  });
